/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Upload_SelectedInputs */

const cs_chat_attach_upload_selected = /** @type {(inputs: Chat_Attach_Upload_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybraný soubor`)
};

const en_chat_attach_upload_selected = /** @type {(inputs: Chat_Attach_Upload_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected file`)
};

/**
* | output |
* | --- |
* | "Selected file" |
*
* @param {Chat_Attach_Upload_SelectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_upload_selected = /** @type {((inputs?: Chat_Attach_Upload_SelectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Upload_SelectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_upload_selected(inputs)
	return cs_chat_attach_upload_selected(inputs)
});